// pdfjs-dist legacy calls Promise.withResolvers without polyfilling it (Chrome < 119).
if (typeof Promise.withResolvers !== "function") {
    Promise.withResolvers = function withResolvers() {
        let resolve, reject;
        const promise = new this((res, rej) => { resolve = res; reject = rej; });
        return { promise, resolve, reject };
    };
}
// pdf.worker compileFontInfo/compileSystemFontInfo call transferToFixedLength (Chrome < 111);
// without it the render of any page after the first hangs.
if (typeof ArrayBuffer.prototype.transferToFixedLength !== "function") {
    // shortcut: no detach emulation, pdf.js only needs a right-sized copy
    ArrayBuffer.prototype.transferToFixedLength = function transferToFixedLength(newLength = this.byteLength) {
        if (newLength === this.byteLength) return this.slice(0);
        const resized = new ArrayBuffer(newLength);
        new Uint8Array(resized).set(new Uint8Array(this, 0, Math.min(newLength, this.byteLength)));
        return resized;
    };
}
// pdf.js AnnotationEditorUIManager (created by PDFViewer.setDocument) calls AbortSignal.any (Chrome < 116).
if (typeof AbortSignal !== "undefined" && typeof AbortSignal.any !== "function") {
    // shortcut: listeners are never removed, fine for the few long-lived signals pdf.js combines
    AbortSignal.any = function any(signals) {
        const controller = new AbortController();
        for (const signal of signals) {
            if (signal.aborted) { controller.abort(signal.reason); break; }
            signal.addEventListener("abort", () => controller.abort(signal.reason), { once: true });
        }
        return controller.signal;
    };
}
